<template>
    <div>
        <v-container class="font-weight-light">
        <!-- HEADER -->
            <v-app-bar elevation="0" dark color="#5D327C" style="border-radius: 8px 8px 0px 0px;">
                <span class="font-weight-regular">{{ client.company }} 
                    <small style="font-weight: 100;"> {{ client.location }} </small>
                    <small>{{ client.tierType }}</small>
                    <small style="font-weight: 100;"> Updated </small>
                    <small>{{ client.updatedDate }}</small>
                </span>
                <v-spacer></v-spacer>
                <v-btn small color="white" elevation="0" class="ml-3" @click="changeStageDialog = true"><span class="button-style" style="color: #5D327C">{{ client.stage }}</span></v-btn>
                <v-btn small color="white" elevation="0" class="ml-3" @click="addNoteDialog = true">><v-icon small color="#5D327C">edit</v-icon><span class="button-style" style="color: #5D327C">Add Note</span></v-btn>
                <v-btn small color="white" elevation="0" class="ml-3" @click="addTaskDialog = true"><v-icon small color="#5D327C">add</v-icon><span class="button-style" style="color: #5D327C">Add Task</span></v-btn>
                <v-btn @click="happinessDialog = true; oldHappiness = client.happinessRating" dark class="ml-3 button-style" small :color="getHappinessColor(client.happinessRating)" elevation="0">
                    <v-icon>
                        {{ getHappinessIcon(client.happinessRating) }}
                    </v-icon>
                    <span class="ml-1">{{ client.happinessRating }}</span>
                </v-btn>
            </v-app-bar>
        <!-- CHANGE STAGE DIALOG -->
            <v-row justify="center">
                <v-dialog v-model="changeStageDialog" max-width="600px">
                    <v-card>
                        <v-card-title>
                            <span class="headline">Change Stage</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" class="pb-0">
                                        <v-text-field v-model="noteInput" outlined label="Enter a note about the stage change..."></v-text-field>
                                        <v-checkbox v-if="noteInput !== null" v-model="stageChangeCheckbox" label="I'm sure I want to do this..."></v-checkbox>
                                    </v-col>
                                    <span class="red--text px-12 mt-0 mt-0">
                                        <strong>{{ stageChangeError }}</strong>
                                    </span>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn elevation="0" class="button-style mb-7" dark color="red darken-1" @click="changeStageDialog = false; noteError = null">Close</v-btn>
                            <v-btn elevation="0" class="button-style mr-7 mb-7" dark color="green darken-1" @click="changeStage()">Save</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        <!-- ADD NOTE DIALOG -->
            <v-row justify="center">
                <v-dialog v-model="addNoteDialog" max-width="600px">
                    <v-card>
                        <v-card-title>
                            <span class="headline">Add a note</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" class="pb-0">
                                        <v-text-field v-model="noteInput" outlined label="Enter a note..." required></v-text-field>
                                    </v-col>
                                    <span class="red--text px-12 mt-0 mt-0">
                                        <strong>{{ noteError }}</strong>
                                    </span>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn elevation="0" class="button-style mb-7" dark color="red darken-1" @click="addNoteDialog = false; noteError = null">Close</v-btn>
                            <v-btn elevation="0" class="button-style mr-7 mb-7" dark color="green darken-1" @click="createNote()">Save</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        <!-- ADD TASK DIALOG -->
            <v-row justify="center">
                <v-dialog v-model="addTaskDialog" max-width="600px">
                    <v-card>
                        <v-card-title>
                            <span class="headline">Create a task</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" class="pb-0">
                                        <v-text-field v-model="taskInput" outlined label="Enter a task..." required></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-autocomplete outlined :items="adminUsers" label="Owner" v-model="taskOwnerEmail"></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-menu v-model="datePickerDialog" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field outlined v-model="taskDueDate" label="Task due date..." prepend-icon="event" readonly v-on="on"></v-text-field>
                                            </template>
                                            <v-date-picker v-model="taskDueDate" @input="datePickerDialog = false"></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <span class="red--text px-12 mt-0 mt-0">
                                        <strong>{{ taskError }}</strong>
                                    </span>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn elevation="0" class="button-style mb-7" dark color="red darken-1" @click="addTaskDialog = false; taskError = null">Close</v-btn>
                            <v-btn elevation="0" class="button-style mr-7 mb-7" dark color="green darken-1" @click="createTask()">Save</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        <!-- HAPPINESS DIALOG -->
            <v-row justify="center">
                <v-dialog v-model="happinessDialog" persistent max-width="600px">
                    <v-card>
                        <v-card-title>
                            <span class="headline">Update client happiness</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row justify="center">
                                    <v-col cols="12" class="px-12 pb-0 pt-12 mb-0">
                                        <v-slider :color="getHappinessColor(client.happinessRating)" thumb-label="always" v-model="client.happinessRating" min="1" max="100" ticks="always" tick-size="0">
                                            <template v-slot:thumb-label="props">
                                                <v-icon dark color="white">
                                                    {{ getHappinessIcon(props.value) }}
                                                </v-icon>
                                            </template>
                                        </v-slider>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-btn elevation="0" @click="client.happinessRating = 5" dark color="red"><v-icon>sentiment_very_dissatisfied</v-icon></v-btn>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-btn elevation="0" @click="client.happinessRating = 25" dark color="orange"><v-icon>sentiment_dissatisfied</v-icon></v-btn>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-btn elevation="0" @click="client.happinessRating = 45" dark color="yellow"><v-icon>sentiment_neutral</v-icon></v-btn>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-btn elevation="0" @click="client.happinessRating = 55" dark color="blue"><v-icon>sentiment_satisfied</v-icon></v-btn>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-btn elevation="0" @click="client.happinessRating = 80" dark color="green"><v-icon>sentiment_very_satisfied</v-icon></v-btn>
                                    </v-col>
                                    <v-col cols="10">
                                        <small>Only update this if you're sure... Only select the best if the client is completely happy!</small>
                                    </v-col>
                                    <v-col cols="12" class="px-12 pb-0 mt-0 mb-0">
                                        <v-text-field v-model="happinessNote" outlined label="Why are you changing the happiness rating?"></v-text-field>
                                    </v-col>
                                    <span class="red--text px-12 mt-0 mt-0">
                                        <strong>{{ happinessError }}</strong>
                                    </span>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn elevation="0" class="button-style mb-7" dark color="red darken-1" @click="happinessDialog = false; client.happinessRating = oldHappiness; happinessNote = null; happinessError = null">Close</v-btn>
                            <v-btn elevation="0" class="button-style mr-7 mb-7" dark color="green darken-1" @click="updateHappiness()">Save</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        <!-- TAB HEADERS -->
            <v-tabs slot="extension" v-model="tab" grow>
                <v-tabs-slider color="#5D327C"></v-tabs-slider>
                    <v-tab>
                    Tasks
                    </v-tab>
                    <v-tab>
                    Notes
                    </v-tab>
                    <v-tab>
                    Company
                    </v-tab>
                    <v-tab>
                    Stats
                    </v-tab>
                    <v-tab>
                    Branding
                    </v-tab>
            </v-tabs>
        <!-- TAB CONTENT -->
            <v-tabs-items v-model="tab">
                <v-tab-item>
                    <Tasks></Tasks>
                </v-tab-item>
                <v-tab-item>
                    <Notes></Notes>
                </v-tab-item>
                <v-tab-item>
                    <Company></Company>
                </v-tab-item>
                <v-tab-item>
                    <stats></stats>
                </v-tab-item>
                <v-tab-item>
                    <branding></branding>
                </v-tab-item>
            </v-tabs-items>
        </v-container>
    </div>
</template>
<script>
import Tasks from '../components/Tasks'
import Company from '../components/Company'
import Notes from '../components/Notes'
import Branding from '../components/Branding'
import Stats from '../components/Stats'
import moment from 'moment'
export default {
    name: 'AccountView',
    data(){
        return {
            id: this.$route.params.id,
            tab: 0,
            client: {},
            addTaskDialog: false,
            taskInput: null,
            taskError: null,
            happinessDialog: false,
            datePickerDialog: false,
            taskDueDate: null,
            addNoteDialog: false,
            noteInput: null,
            noteError: null,
            changeStageDialog: false,
            stageChangeCheckbox: false,
            stageChangeError: null,
            oldHappiness: null,
            happinessNote: null,
            happinessError: null,
            currentAdminUser: this.$store.getters.currentAdminUser,
            adminUser: this.$store.getters.currentAdminUser,
            taskOwnerEmail: this.$store.getters.currentAdminUser.email,
            adminUsers: ['patrick@vaboo.co.uk', 'jon@vaboo.co.uk', 'matt@vaboo.co.uk', 'hsmith@vaboo.co.uk'],
        }
    },
    components: {
        Tasks,
        Company,
        Notes,
        Branding,
        Stats
    },
    methods: {
        getHappinessIcon (happinessRating) {
            if (happinessRating < 20) return 'sentiment_very_dissatisfied'
            else if (happinessRating < 40) return 'sentiment_dissatisfied'
            else if (happinessRating < 50) return 'sentiment_neutral'
            else if (happinessRating < 75) return 'sentiment_satisfied'
            else return 'sentiment_very_satisfied'
        },
        getHappinessColor (happinessRating) {
            if (happinessRating < 20) return 'red'
            else if (happinessRating < 40) return 'orange'
            else if (happinessRating < 50) return 'yellow'
            else if (happinessRating < 75) return 'blue'
            else return 'green'
        },
        createTask(){
            this.taskError = null
            if(this.taskInput == null){
                this.taskError = 'Enter a task'
            }else if(this.taskDueDate == null){
                this.taskError = 'Add a due date...'
            }else{
                // name for task
                var createdDate = moment(new Date()).format('x').toString()
                // create new task
                let taskType = ''
                if(this.client.stage == 'Onboarding'){
                    taskType = 'Onboarding Task Created'
                }else{
                    taskType = 'Management Task Created'
                }
                var newTask = {
                    createdDate: createdDate,
                    authorEmail: this.adminUser.email,
                    authorFirstName: this.adminUser.firstName,
                    authorLastName: this.adminUser.lastName,
                    authorShort: this.adminUser.short,
                    company: this.client.company,
                    companyID: this.id,
                    star: false,
                    text: this.taskInput,
                    stage: this.client.stage,
                    time: createdDate,
                    type: taskType,
                    completed: false,
                    completedBy: null,
                    completedDate: null,
                    dueDate: this.taskDueDate,
                    owner: this.taskOwnerEmail
                }
                // push task to database
                firebase.firestore().collection('clients').doc(this.id).collection('tasks').doc(createdDate).set(newTask).catch(err => { console.log('Error:', err) })
                // update number of tasks in main client document
                if(this.client.stage == 'Onboarding'){
                    this.client.totalOnboardingTasks ++
                }else{
                    this.client.totalManagementTasks ++
                }
                this.client.updatedDate = createdDate
                this.client.updatedBy = this.adminUser.email
                firebase.firestore().collection('clients').doc(this.id).update(this.client)
                // add to activity feed DO THIS
                firebase.firestore().collection('activity').doc(createdDate).set(newTask).catch(err => { console.log('Error:', err) })
                // clear the input
                this.taskInput = null
                this.taskError = null
                this.taskDueDate = null
                this.taskOwnerEmail = this.adminUser.email
                this.addTaskDialog = false
            }
        },
        createNote(){
            let time = Number(new Date())
            this.noteError = null
            if(this.noteInput == null){
                this.noteError = 'Enter a note'
            }else{
                // name for note
                var createdDate = moment(new Date()).format('x').toString()
                // create new note
                let noteType = ''
                if(this.client.stage == 'Onboarding'){
                    noteType = 'Onboarding Note Created'
                }else{
                    noteType = 'Management Note Created'
                }
                let comment = {
                    company: this.client.company,
                    text: this.noteInput,
                    star: false,
                    time: time.toString(),
                    authorEmail: this.adminUser.email,
                    authorFirstName: this.adminUser.firstName,
                    authorLastName: this.adminUser.lastName,
                    authorShort: this.adminUser.short,
                    type: noteType,
                    companyID: this.id,
                    stage: this.client.stage
                }
                // push comment to database
                if(this.client.stage == 'Onboarding'){
                    firebase.firestore().collection('clients').doc(this.id).collection('onboarding-notes').doc(time.toString()).set(comment)
                }else{
                    firebase.firestore().collection('clients').doc(this.id).collection('management-notes').doc(time.toString()).set(comment)
                }
                // push comment to activity feed
                firebase.firestore().collection('activity').doc(time.toString()).set(comment)
                // update 'most recent comment' in client document
                var newComment = firebase.firestore().collection('clients').doc(this.id)
                firebase.firestore().runTransaction(t => { return t.get(newComment).then(doc => {
                        t.update(newComment, {mostRecentNote: comment.text, mostRecentNoteTime: time.toString(), updatedDate: time.toString(), updatedBy: this.adminUser.email })
                    })
                }).catch(err => { console.log('Transaction failure:', err) })
                this.noteInput = null
                this.noteError = null
                this.stageChangeError = null
                this.addNoteDialog = false
                this.changeStageDialog = false
            }
        },
        changeStage(){
            this.stageChangeError = null
            if(this.noteInput == null){
                this.stageChangeError = 'Enter a note to change the stage'
            }else if(this.stageChangeCheckbox == false){
                this.stageChangeError = 'Check the box if you\'re sure you want to change the stage...'
            }else{
                this.noteError = null
                var time = Number(moment(new Date).format('x'))
                // change client stage in database
                var newStage = ''
                var stageType = ''
                if(this.client.stage == 'Onboarding'){
                    newStage = 'Management'
                    stageType = 'Onboarding Complete'
                }else{
                    newStage = 'Onboarding'
                    stageType = 'Onboarding Failed'
                }
                this.client.stage = newStage
                this.client.updatedDate = time
                this.client.updatedBy = this.adminUser.email
                let comment = {
                    company: this.client.company,
                    text: this.noteInput,
                    star: false,
                    time: time.toString(),
                    authorEmail: this.adminUser.email,
                    authorFirstName: this.adminUser.firstName,
                    authorLastName: this.adminUser.lastName,
                    authorShort: this.adminUser.short,
                    type: stageType,
                    companyID: this.id,
                    stage: this.client.stage
                }
                firebase.firestore().collection('clients').doc(this.client.id).update(this.client)
                .then(() => {
                    this.createNote()
                })
                .catch(err => { console.log('Transaction failure:', err) })
                firebase.firestore().collection('activity').doc(time.toString()).set(comment)
            }
        },
        updateHappiness(){
            this.happinessError = null
            if(this.happinessNote == null){
                this.happinessError = 'You need to enter note to explain why this change is being made...'
            }else if(this.client.happinessRating == this.oldHappiness){
                this.happinessError = 'You need to enter a new value to update this...'
            }else{
                let time = Number(new Date())
                var createdDate = moment(new Date()).format('x').toString()
                // create new note
                let noteType = ''
                if(this.client.stage == 'Onboarding'){
                    noteType = 'Onboarding Happiness Changed'
                }else{
                    noteType = 'Management Happiness Changed'
                }
                let comment = {
                    company: this.client.company,
                    text: this.happinessNote,
                    star: false,
                    time: time.toString(),
                    authorEmail: this.adminUser.email,
                    authorFirstName: this.adminUser.firstName,
                    authorLastName: this.adminUser.lastName,
                    authorShort: this.adminUser.short,
                    type: noteType,
                    companyID: this.id,
                    stage: this.client.stage,
                    oldHappiness: this.oldHappiness,
                    newHappiness: this.client.happinessRating
                }
                // push comment to database
                if(this.client.stage == 'Onboarding'){
                    firebase.firestore().collection('clients').doc(this.id).collection('onboarding-happiness-notes').doc(time.toString()).set(comment)
                }else{
                    firebase.firestore().collection('clients').doc(this.id).collection('management-happiness-notes').doc(time.toString()).set(comment)
                }
                // push comment to activity feed
                firebase.firestore().collection('activity').doc(time.toString()).set(comment)
                // update 'most recent comment' in client document
                this.client.updatedDate = time
                this.client.updatedBy = this.adminUser.email
                this.client.mostRecentNote = this.noteInput
                this.client.mostRecentNoteTime = time
                this.client.mostRecentNoteAuthor = this.adminUser.email
                firebase.firestore().collection('clients').doc(this.id).update(this.client)
                .then(() => {
                    this.happinesNote = null
                    this.happinessDialog = false
                })
                .catch(err => { console.log(err) })
            }
        }
    },
    mounted(){
    // populate basic information for this parent component
        firebase.firestore().collection('clients').doc(this.id).onSnapshot(docSnapshot => {
            this.client = docSnapshot.data()
            this.client.updatedDate = moment(Number(docSnapshot.data().updatedDate)).fromNow()
            this.$store.dispatch('setCurrentClient', this.client)
            document.title = this.client.company + ' - Account View'
        }, err => { console.log(`Encountered error: ${err}`) })
    }
}
</script>
<style>
</style>